import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import apis from '#store/api';
import { DataApiResponse, DataCollectionApiResponse } from './types';

export const ORGANIZATION_ROLE_KEY = 'organizationRole';

export interface OrganizationRole {
  id: string;
  role: string;
  letter: string;
  color: string;
}


export interface GetOrganizationRolesParams {
  skip: number;
  take?: number;
}

export interface GetOrganizationRoleByIdParams {
  id: string;
}

export interface UpdateOrganizationRoleParams {
  role: OrganizationRole;
}

export const useOrganizationRoles = (params: GetOrganizationRolesParams) => {
  return useQuery({
    queryKey: [ORGANIZATION_ROLE_KEY, params],
    queryFn: async () => {
      const response = await apis.organizationRoles.getOrganizationRoles({ params });
      return response.data as DataCollectionApiResponse<OrganizationRole>;
    },
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
  });
};

export const useOrganizationRoleById = (params: GetOrganizationRoleByIdParams) => {
  return useQuery({
    queryKey: [ORGANIZATION_ROLE_KEY, params],
    queryFn: async () => {
      const response = await apis.organizationRoles.getOrganizationRoleById({ data: params });
      return response.data as DataApiResponse<OrganizationRole>;
    },
  });
};

export const useUpdateOrganizationRole = () => {
  const queryClient = useQueryClient();

  return useMutation<any, Error, UpdateOrganizationRoleParams>({
    mutationFn: async (params: UpdateOrganizationRoleParams) => {
      const response = await apis.organizationRoles.updateOrganizationRole({ data: params.role });
      return response.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [ORGANIZATION_ROLE_KEY] });
    },
  });
};
